import React from "react";
// import ReactDOM from "react-dom";
import * as ReactDOM from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import { history } from "./history";
// import reportWebVitals from "./reportWebVitals";
import rootReducer from "./reducers";
import rootSaga from "./sagas";
import { installInterceptors } from './common/services/api.service';


const sagaMiddleware = createSagaMiddleware();
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      immutableCheck: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);
installInterceptors();
const root = ReactDOM.createRoot(document.getElementById("root")!);
const element = (
  // <React.StrictMode>
  <Provider store={store}>
    <HistoryRouter
      history={history as any}>
      <App />
    </HistoryRouter>
  </Provider>
  // </React.StrictMode>
);
root.render(element);

// reportWebVitals();
